import { useEffect } from "react";

import { useGlobalConfig } from "@shared/context";
import { useAnalyticsStartExperimentMutation } from "@shared/data/mutations/AnalyticsStartExperimentMutation";

const useSimplifySignUpExperiment = experimentVariant => {
  const { isFromWellevate, isFromEmersonEcologics } = useGlobalConfig();
  const [analyticsStartExperiment] = useAnalyticsStartExperimentMutation({});
  const experimentName = "gambit_simplify_sign_up";
  const experimentOverride = localStorage?.getItem(experimentName) || experimentVariant;

  const isFromWellevateOrEmerson = isFromWellevate || isFromEmersonEcologics;
  useEffect(() => {
    if (experimentVariant !== null) {
      analyticsStartExperiment({
        variables: {
          input: {
            experiment: experimentName,
            experimentVariant: experimentOverride,
          },
        },
      });
    }
  }, [experimentOverride]);

  const ssuEnabled = () =>
    experimentOverride === "simplify_sign_up" || experimentOverride === "simplify_sign_up_with_tos";

  const isSignupEnabled = () => {
    if (ssuEnabled() && !isFromWellevateOrEmerson) {
      return true;
    } else {
      return false;
    }
  };

  return {
    isSimplifySignUpEnabled: isSignupEnabled(),
    isExplicitTosExperiment: experimentOverride === "simplify_sign_up_with_tos",
  };
};

export { useSimplifySignUpExperiment };
